module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/end1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "halftitle"
  }, [_vm._v("The Gardener Says")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "first1_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Also available in the"), _c('br'), _vm._v("Words of Wisdom series:")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('span', {
    staticClass: "font5"
  }, [_c('strong', [_vm._v("The Architect Says")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Laura S. Dushkes")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('span', {
    staticClass: "font5"
  }, [_c('strong', [_vm._v("The Designer Says")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Sara Bader")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('span', {
    staticClass: "font5"
  }, [_c('strong', [_vm._v("The Filmmaker Says")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Jamie Thompson Stern")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('span', {
    staticClass: "font5"
  }, [_c('strong', [_vm._v("The Chef Says")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Nach Waxman and Matt Sartwell")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('span', {
    staticClass: "font5"
  }, [_c('strong', [_vm._v("The Musician Says")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Benedetta LoBalbo")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('span', {
    staticClass: "font5"
  }, [_c('strong', [_vm._v("The Inventor Says")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Kevin Lippert")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('span', {
    staticClass: "font5"
  }, [_c('strong', [_vm._v("The Writer Says")])])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Kevin Lippert")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7652280c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02frontmatter.vue
// module id = 60
// module chunks = 0